// extracted by mini-css-extract-plugin
export default {"brandPromo":"XF-z","carousel":"YF-z"};